<template>
  <div class="bottom-tab">
    <slot name="tips"></slot>
    <div class="flex align-center space-between tab" :style="{ background: background }" :class="{ border: border }">
      <div class="left flex align-center space-between nowrap" :style="{ width: leftWidth }">
        <slot name="left"></slot>
      </div>

      <div class="right flex align-center space-between nowrap" style="height: 100%">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftWidth: {
      type: String,
      default: 'unset'
    },
    background: {
      type: String,
      default: '#fff'
    },
    border: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
@tabH: 48px;
.bottom-tab {
  .border {
    box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.25);
    height: @tabH;
  }
  width: 100%;

  .tab {
    // height: 100%;
    line-height: @tabH;
    text-align: center;
  }

  .right {
    flex: 1;
    * > {
      flex: 1;
    }
  }
}
</style>
